import { PermissionAction } from "./actions";
import { OrganizationRole } from "./roles";
import { PermissionSubject } from "./subjects";

export type PermissionString = `${PermissionAction}:${PermissionSubject}`;

export function formatPermission(action: PermissionAction, subject: PermissionSubject): PermissionString {
  return `${action}:${subject}`;
}

export function parsePermission(permission: string): { action: string; subject: string } {
  const separatorIndex = permission.indexOf(":");
  if (separatorIndex === -1) {
    return { action: permission, subject: "all" };
  }
  return {
    action: permission.slice(0, separatorIndex),
    subject: permission.slice(separatorIndex + 1),
  };
}

const p = formatPermission;

export const ROLE_PERMISSION_PRESETS: Record<string, PermissionString[]> = {
  [OrganizationRole.ADMIN]: [p(PermissionAction.MANAGE, PermissionSubject.ALL)],
  [OrganizationRole.MEMBER]: [
    p(PermissionAction.READ, PermissionSubject.ORGANIZATION),
    p(PermissionAction.READ, PermissionSubject.USER),
    p(PermissionAction.MANAGE, PermissionSubject.PROJECT),
  ],
};
